<template>
    <div class="modal-body relative  w-full flex flex-col gap-3 h-full p-3 bg-gray-50" :class="{'cursor-wait' : isLoading || postsLoading}">
        <form @submit.prevent="submitForm">
            <!-- <base-form>
                <template #body> -->
                    <div class="flex flex-col gap-3">
                        <div class="w-full bg-white rounded-xl border border-gray-200 p-3">
                            <h3 class="text-lg font-semibold text-gray-900 mb-1">Invoice Info</h3>
                            <div class="flex flex-wrap items-end gap-6">
                                <div class="flex flex-col gap-1">
                                    <label for="status" class="text-sm text-gray-600">Status</label>
                                    <select class="border border-dark-primary rounded-md p-1 w-48" name="status" id="status" v-model="invoiceData.status">
                                        <option value="Draft">Draft</option>
                                        <option value="Paid">Paid</option>
                                        <option value="Unpaid">Unpaid</option>
                                        <option value="Write Off">Write Off</option>
                                        <option value="Void">Void</option>
                                        <option value="Paused">Paused</option>
                                    </select>
                                </div>
                                <div class="flex flex-col gap-1">
                                    <label for="sentDate" class="text-sm text-gray-600">Sent Date</label>
                                    <div class="flex items-center gap-1">
                                        <input type="date" id="sentDate" v-model="invoiceData.sent_date" class="border border-dark-primary rounded-md p-1">
                                        <button type="button" v-if="invoiceData.sent_date" @click="invoiceData.sent_date = null" title="Clear sent date" class="shrink-0 text-gray-500 hover:text-red-600 px-1 text-lg leading-none">&times;</button>
                                    </div>
                                </div>
                                <div class="self-stretch border-l border-gray-200"></div>
                                <div class="flex items-center gap-10 h-[34px]">
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" id="isRetainer" v-model="invoiceData.is_retainer_fee" class="h-4 w-4">
                                        <label for="isRetainer" class="text-gray-700">Is Retainer</label>
                                        <span class="group relative cursor-help font-bold text-dark-primary hover:text-accent-primary">
                                            ⓘ
                                            <span class="pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">Uncheck for off-cycle / expense invoices</span>
                                        </span>
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <input type="checkbox" id="hideFromStatement" v-model="invoiceData.hide_from_statement" class="h-4 w-4">
                                        <label for="hideFromStatement" class="text-gray-700">Hide from Statement</label>
                                        <span class="group relative cursor-help font-bold text-dark-primary hover:text-accent-primary">
                                            ⓘ
                                            <span class="pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">Exclude this invoice from the statement of accounts PDF</span>
                                        </span>
                                    </div>
                                </div>
                                <base-button-affirmative class="px-3 mb-1.5" :disabled="isLoading" @click.prevent="submitForm">
                                    {{ isLoading ? 'Saving…' : 'Save' }}
                                </base-button-affirmative>
                            </div>
                        </div>
                        <div class="w-full bg-white rounded-xl border border-gray-200 p-3">
                            <div class="flex items-baseline gap-3 mb-1">
                                <h3 class="text-lg font-semibold text-gray-900">Payments</h3>
                                <span class="text-sm text-gray-600">{{ formatMoney(amountPaid) }} of {{ formatMoney(invoice.invoice_amount) }} paid | {{ formatMoney(balance) }} balance</span>
                                <div v-if="balance > 0" class="ml-auto">
                                    <span v-if="confirmingWaive" class="inline-flex items-center gap-2 whitespace-nowrap text-sm">
                                        <span>Waive {{ formatMoney(balance) }}?</span>
                                        <input type="text" v-model="waiveNote" maxlength="100" placeholder="Reason (optional)" class="border border-dark-primary rounded-md p-1 w-56">
                                        <button type="button" :disabled="paymentsLoading" class="-my-1 rounded-md border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700 hover:bg-sky-100 hover:shadow-md" @click="waiveBalance">Yes</button>
                                        <button type="button" class="-my-1 rounded-md border border-gray-300 bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200 hover:shadow-md" @click="confirmingWaive = false">No</button>
                                    </span>
                                    <button v-else type="button" class="text-xs text-accent-primary font-medium hover:underline" @click="confirmingWaive = true">Waive remaining balance</button>
                                </div>
                            </div>
                            <div class="rounded-lg bg-slate-100 p-3">
                                <h4 class="font-semibold text-gray-900 mb-1">Add Payment</h4>
                                <div class="flex items-end gap-3">
                                    <div class="flex flex-col gap-1">
                                        <label for="paymentDate" class="text-sm text-gray-600">Payment Date</label>
                                        <input type="date" id="paymentDate" v-model="paymentData.date_paid" class="border border-dark-primary rounded-md p-1">
                                    </div>
                                    <div class="flex flex-col gap-1">
                                        <label for="paymentAmount" class="text-sm text-gray-600">Amount</label>
                                        <div class="flex items-center">
                                            $<input type="number" id="paymentAmount" min="0" step="0.01" placeholder="0.00" v-model="paymentData.amount" class="border border-dark-primary rounded-md p-1 w-32">
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-1">
                                        <label for="paymentType" class="text-sm text-gray-600">Payment Type</label>
                                        <select id="paymentType" v-model="paymentData.payment_type" class="border border-dark-primary rounded-md p-1 w-32">
                                            <option value="" disabled>Select type</option>
                                            <option v-for="type in PAYMENT_TYPES" :key="type" :value="type">{{ type }}</option>
                                        </select>
                                    </div>
                                    <div class="flex flex-col gap-1">
                                        <label for="paymentNote" class="text-sm text-gray-600">Note</label>
                                        <input type="text" id="paymentNote" v-model="paymentData.note" maxlength="100" placeholder="Check #, wire ref… (optional)" class="border border-dark-primary rounded-md p-1 w-64">
                                    </div>
                                    <div class="flex h-[34px] shrink-0 items-center">
                                        <base-button-affirmative class="whitespace-nowrap px-3" :disabled="paymentsLoading" @click.prevent="submitPayment">
                                            {{ paymentsLoading ? 'Saving…' : 'Add Payment' }}
                                        </base-button-affirmative>
                                    </div>
                                </div>
                            </div>
                            <h4 class="font-semibold text-gray-900 mt-3 mb-1">Payment History ({{ payments.length }})</h4>
                            <div v-if="payments.length" class="rounded-lg border border-gray-200 overflow-hidden">
                                <table class="w-full table-fixed text-sm">
                                    <thead class="bg-slate-50 text-left text-gray-600">
                                        <tr>
                                            <th class="w-[15%] px-4 py-2 font-medium">Date</th>
                                            <th class="w-[15%] px-4 py-2 font-medium">Amount</th>
                                            <th class="w-[15%] px-4 py-2 font-medium">Payment Type</th>
                                            <th class="w-[25%] px-4 py-2 font-medium">Notes</th>
                                            <th class="w-[30%] px-4 py-2 font-medium">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="payment in payments" :key="payment.id" class="border-t border-gray-200">
                                            <td class="px-4 py-2">{{ returnDate(payment.date_paid) }}</td>
                                            <td class="px-4 py-2">{{ formatMoney(payment.amount) }}</td>
                                            <td class="px-4 py-2">{{ payment.payment_type || '—' }}</td>
                                            <td class="px-4 py-2 truncate text-gray-600" :title="payment.note">{{ payment.note }}</td>
                                            <td class="px-4 py-2">
                                                <span v-if="confirmingDeleteId === payment.id" class="inline-flex items-center gap-2 whitespace-nowrap">
                                                    <span>Delete this payment?</span>
                                                    <button type="button" class="-my-1 rounded-md border border-red-200 bg-red-50 px-3 py-1 text-xs font-medium text-red-700 hover:bg-red-100 hover:shadow-md" @click="deletePayment(payment.id)">Yes</button>
                                                    <button type="button" class="-my-1 rounded-md border border-gray-300 bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200 hover:shadow-md" @click="confirmingDeleteId = null">No</button>
                                                </span>
                                                <button v-else type="button" class="text-red-600 font-medium hover:underline" @click="confirmingDeleteId = payment.id">Delete</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="bg-slate-50 font-semibold text-gray-900">
                                        <tr class="border-t border-gray-200">
                                            <td class="px-4 py-3">Total Payments</td>
                                            <td class="px-4 py-3" colspan="4">{{ formatMoney(amountPaid) }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div v-else class="text-sm text-gray-500">No payments recorded.</div>
                        </div>
                        <div class="w-full bg-white rounded-xl border border-gray-200 p-3">
                            <h3 class="text-lg font-semibold text-gray-900 mb-1">Accounting Posts</h3>
                            <div class="flex flex-col items-center space-y-2 max-h-96 overflow-auto">
                                <div class="flex flex-col items-center w-full rounded-md">
                                    <textarea class="border border-dark-primary rounded-md p-2 w-full" name="" id=""  rows="2" placeholder="New accounting post..." v-model="accountingPostData.post_body"></textarea>
                                    <div v-if="postsLoading" role="status" class="p-3">
                                        <svg aria-hidden="true" class="mx-1 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="#d3d3d3"/>
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="#2E9CCA"/>
                                        </svg>
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <base-button-affirmative class="mt-1" v-else @click.prevent="submitAccountingPost">Add Post</base-button-affirmative>
                                </div>
                                <transition-group name="accountingPosts">
                                    <div v-for="post in invoice.accounting_posts" class="w-full"  :key="post.id">
                                        <InvoiceAccountingPost :post="post" @remove-post="removePost" @refetch-invoices="fetchNewInvoices"/>
                                    </div>
                                    <!-- <div v-for="post in invoice.accounting_posts" :key="post.id" class="border border-dark-primary rounded-md p-2 w-full flex flex-col">
                                        <div class="flex justify-between border-b py-1 items-center">
                                            <div class="flex space-x-2">
                                                <div>
                                                    {{ returnDate(post.created_at) }}
                                                </div>
                                                <div>
                                                    {{ post.created_by.first_name }} {{ post.created_by.last_name }}:
                                                </div>
                                            </div>
                                            <div>
                                                <base-button v-if="isPostOwner(post.created_by.id)" @click.prevent="removePost(post.id)">🗑</base-button>
                                            </div>
                                        </div>
                                        {{ post.post_body }}
                                    </div> -->
                                </transition-group>
                            </div>
                        </div>
                    </div>
                <!-- </template> -->
                <!-- <template #footer>
                    <div class="flex justify-center w-full p-2">
                        <div v-if="isLoading" role="status" class="pl-3">
                            <svg aria-hidden="true" class="mx-1 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="#d3d3d3"/>
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="#2E9CCA"/>
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                        <base-button-affirmative v-else>Save</base-button-affirmative>
                    </div>
                </template> -->
            <!-- </base-form> -->
        </form>
        <div class="bg-white rounded-xl border border-gray-200 p-3 text-sm">
            <h3 class="text-lg font-semibold text-gray-900 mb-1">Saved PDFs</h3>
            <div v-if="pdfHistoryLoading" class="text-gray-500">Loading…</div>
            <table v-else-if="pdfHistory.length" class="w-full">
                <thead>
                    <tr class="bg-gray-100">
                        <th class="text-left p-1">Saved at</th>
                        <th class="text-left p-1">By</th>
                        <th class="text-left p-1">Size</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="pdf in pdfHistory" :key="pdf.id" class="border-b">
                        <td class="p-1">{{ new Date(pdf.created_at).toLocaleString() }}</td>
                        <td class="p-1">{{ pdf.created_by ? `${pdf.created_by.first_name} ${pdf.created_by.last_name}` : '—' }}</td>
                        <td class="p-1">{{ pdf.size_bytes ? Math.round(pdf.size_bytes / 1024) + ' KB' : '—' }}</td>
                        <td class="p-1">
                            <a :href="pdf.file_url" target="_blank" rel="noopener" class="text-accent-primary underline">Open</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="text-gray-500">No archived PDFs.</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'invoice-form'
}
</script>

<script setup>
import { useStore } from 'vuex';
import {ref, computed, defineProps, defineEmits, reactive, onMounted} from 'vue';
import { updateInvoice, addInvoiceAccountingNote, listInvoicePdfs, addInvoicePayment, deleteInvoicePayment, waiveInvoiceBalance } from '@/services/Invoice';
import { useToast } from 'vue-toast-notification';
import { deleteAccountingPost } from '@/services/AccountingPost'
import InvoiceAccountingPost from './InvoiceAccountingPost.vue';

const store = useStore()

const $toast = useToast()

const props = defineProps({
    invoice: Object
})

function isPostOwner(postOwnerId) {
    return postOwnerId === store.state.auth.user.id
}

const emit = defineEmits(['refetch-invoices', 'invoice-changed', 'close'])


const invoiceData = reactive({
    status: props.invoice.status,
    sent_date: props.invoice.sent_date ? props.invoice.sent_date : null,
    is_retainer_fee: !!props.invoice.is_retainer_fee,
    hide_from_statement: !!props.invoice.hide_from_statement
})

const accountingPostData = reactive({
    post_body: null
})

const isLoading = ref(false)
const postsLoading = ref(false)

const payments = ref(props.invoice.payments || [])
const paymentsLoading = ref(false)
const confirmingDeleteId = ref(null)

const amountPaid = computed(() => {
    return payments.value.reduce((total, payment) => total + Number(payment.amount), 0)
})

const balance = computed(() => {
    return Number(props.invoice.invoice_amount || 0) - amountPaid.value
})

const paymentData = reactive({
    date_paid: new Date().toLocaleDateString('en-CA'),
    amount: balance.value > 0 ? balance.value.toFixed(2) : null,
    payment_type: '',
    note: ''
})

const PAYMENT_TYPES = ['Wire', 'ACH', 'Check']
const confirmingWaive = ref(false)
const waiveNote = ref('')

const moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

function formatMoney(value) {
    return moneyFormatter.format(Number(value || 0))
}

function applyInvoiceResponse(updatedInvoice) {
    payments.value = updatedInvoice.payments || []
    invoiceData.status = updatedInvoice.status
}

function errorMessage(result, fallback) {
    const data = result.response && result.response.data
    if (data && typeof data === 'object') {
        return Object.values(data).flat().join(' ')
    }
    return fallback
}

async function submitPayment() {
    if (!paymentData.date_paid || !(Number(paymentData.amount) > 0) || !paymentData.payment_type) {
        $toast.open({
            message: 'Enter a date, an amount greater than 0 and a payment type',
            type: 'error',
            duration: 5000
        })
        return
    }
    paymentsLoading.value = true
    const token = store.state.auth.token
    const data = JSON.stringify({
        amount: paymentData.amount,
        date_paid: paymentData.date_paid,
        payment_type: paymentData.payment_type,
        note: paymentData.note || null
    })
    const result = await addInvoicePayment(props.invoice.id, data, token)
    if (result.status === 201) {
        applyInvoiceResponse(result.data)
        $toast.open({
            message: `Successfully added payment to Invoice ${props.invoice.invoice_number}`,
            type: 'success',
            duration: 5000
        })
        paymentData.amount = balance.value > 0 ? balance.value.toFixed(2) : null
        paymentData.payment_type = ''
        paymentData.note = ''
        emit('invoice-changed')
    } else {
        $toast.open({
            message: errorMessage(result, `Error, could not add payment to Invoice ${props.invoice.invoice_number}`),
            type: 'error',
            duration: 5000
        })
    }
    paymentsLoading.value = false
}

async function waiveBalance() {
    paymentsLoading.value = true
    const token = store.state.auth.token
    const data = JSON.stringify({ note: waiveNote.value || null })
    const result = await waiveInvoiceBalance(props.invoice.id, data, token)
    if (result.status === 201) {
        applyInvoiceResponse(result.data)
        $toast.open({
            message: `Successfully waived remaining balance on Invoice ${props.invoice.invoice_number}`,
            type: 'success',
            duration: 5000
        })
        confirmingWaive.value = false
        waiveNote.value = ''
        paymentData.amount = balance.value > 0 ? balance.value.toFixed(2) : null
        emit('invoice-changed')
    } else {
        $toast.open({
            message: errorMessage(result, `Error, could not waive balance on Invoice ${props.invoice.invoice_number}`),
            type: 'error',
            duration: 5000
        })
    }
    paymentsLoading.value = false
}

async function deletePayment(paymentId) {
    confirmingDeleteId.value = null
    paymentsLoading.value = true
    const token = store.state.auth.token
    const result = await deleteInvoicePayment(props.invoice.id, paymentId, token)
    if (result.status === 200) {
        applyInvoiceResponse(result.data)
        $toast.open({
            message: `Successfully deleted payment on Invoice ${props.invoice.invoice_number}`,
            type: 'success',
            duration: 5000
        })
        paymentData.amount = balance.value > 0 ? balance.value.toFixed(2) : null
        emit('invoice-changed')
    } else {
        $toast.open({
            message: errorMessage(result, `Error, could not delete payment on Invoice ${props.invoice.invoice_number}`),
            type: 'error',
            duration: 5000
        })
    }
    paymentsLoading.value = false
}

const pdfHistory = ref([])
const pdfHistoryLoading = ref(false)

onMounted(async () => {
    pdfHistoryLoading.value = true
    try {
        pdfHistory.value = await listInvoicePdfs(props.invoice.id, store.state.auth.token)
    } catch (err) {
        console.error('Failed to load PDF history', err)
        pdfHistory.value = []
    } finally {
        pdfHistoryLoading.value = false
    }
})

async function submitForm() {
    isLoading.value = true
    const token = store.state.auth.token
    // Cleared date inputs yield "" which the API's DateField rejects;
    // coerce empty dates back to null before sending.
    const payload = {
        ...invoiceData,
        sent_date: invoiceData.sent_date || null,
    }
    const data = JSON.stringify(payload)
    const result = await updateInvoice(props.invoice.id, data, token)
    if(result.status === 200){
        $toast.open({
                    message: `Successfully updated ${props.invoice.invoice_number}`,
                    type: 'success',
                    duration: 5000
                })
    } else {
        $toast.open({
                    message: `Error, could not update ${props.invoice.invoice_number}`,
                    type: 'error',
                    duration: 5000
                })
    }
    emit('invoice-changed')
    isLoading.value = false


}

async function submitAccountingPost() {
    postsLoading.value = true
    const token = store.state.auth.token
    const data = JSON.stringify(accountingPostData)
    const result = await addInvoiceAccountingNote(props.invoice.id, data, token)
    if(result.status === 200){
        $toast.open({
                    message: `Successfully added Accounting Post to Invoice ${props.invoice.invoice_number}`,
                    type: 'success',
                    duration: 5000
                })
        accountingPostData.post_body = ''
    } else {
        $toast.open({
                    message: `Error, could not add Accounting Post to Invoice ${props.invoice.invoice_number}`,
                    type: 'error',
                    duration: 5000
                })
    }
    emit('refetch-invoices')
    postsLoading.value = false
}

function fetchNewInvoices(){
    emit('refetch-invoices')
}

async function removePost(postId) {
    const token = store.state.auth.token
    postsLoading.value = true 
    const response = await deleteAccountingPost(token, postId)
    emit('refetch-invoices')
    postsLoading.value = false
}

const returnDate = (inputDate) => {
        let date = new Date(inputDate)
        date.setDate(date.getDate() + 1)
        return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
    }


</script>

<style>
.accountingPosts-enter-active,
.accountingPosts-leave-active {
  transition: all 0.5s ease;
}
.accountingPosts-enter-from,
.accountingPosts-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>